import { useMutation } from "react-query";
import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers/internalApi";

interface MarkAsReadProps {
  conversationId: string;
}

export const useMarkAsRead = () => {
  const { mutate: markAsRead } = useMutation({
    mutationFn: ({ conversationId }: MarkAsReadProps) =>
      reactQueryPost(internalApi.helpWidget.markAsRead({ id: conversationId })),
  });

  return { markAsRead };
};
